export default "__VITE_ASSET__2aedb49a__"